// Theme navigation starts
// --------------------------------------------------------------------------------------------------------------------

const navbar = $("#navbar");
const siteHeaderMenu = $(".navbar-nav");

const siteHeader = document.querySelector("#header");
// Hamburger menu icon
const hamburger = document.querySelector(".navbar-toggler");
// On click
hamburger.addEventListener("click", () => {
    // Toggle class "is-active"
    hamburger.classList.toggle("is-active");
    siteHeader.classList.toggle("nav-menu-is-active");

    // $('#navbar').toggleClass('show');
});

// Toggles the sub-menu when dropdown toggle button accessed
siteHeaderMenu.find(".dropdown-toggle").on("click", function (e) {
    const dropdownMenu = $(this).nextAll(".dropdown-menu");

    if ($(this).siblings("a").attr("href") !== "#") {
        $(this).toggleClass("toggled-on");
        dropdownMenu.toggleClass("toggled-on");

        $(this)
            .next(".dropdown-menu")
            .attr(
                "aria-hidden",
                $(this).next(".dropdown-menu").attr("aria-hidden") === "true"
                    ? "false"
                    : "true"
            );

        $(this).attr(
            "aria-expanded",
            $(this).attr("aria-expanded") === "false" ? "true" : "false"
        );
    }
});

// Aria arvot hoverille
siteHeaderMenu.find(".sub-menu-parent").on("mouseenter", function (e) {
    $(this)
        .children(".dropdown-menu")
        .attr(
            "aria-hidden",
            $(this).children(".dropdown-menu").attr("aria-hidden") === "true"
                ? "false"
                : "true"
        );
});

// jos päämenun linkillä  on linkkinä #, niin avataan pudotusvalikko klikattaessa
function menuWithTag() {
    $(".sub-menu-parent").on("click", function (e) {
        const $this = $(this);

        if ($this.children(".nav-link").attr("href") === "#") {
            $this.children(".dropdown-toggle").toggleClass("toggled-on");
            $this.children(".dropdown-menu").toggleClass("toggled-on");

            $(this)
                .children(".dropdown-menu")
                .attr(
                    "aria-hidden",
                    $(this).children(".dropdown-menu").attr("aria-hidden") ===
                        "true"
                        ? "false"
                        : "true"
                );

            $(this)
                .children(".dropdown-toggle")
                .attr(
                    "aria-expanded",
                    $(this)
                        .children(".dropdown-toggle")
                        .attr("aria-expanded") === "false"
                        ? "true"
                        : "false"
                );
        }
    });

    $(".sub-menu-parent > ul").on("click", function (e) {
        e.stopPropagation();
    });
}

// If sub-menu link has href="#", open dropdown on click
document.querySelectorAll(".sub-sub-menu-parent").forEach((subMenuParent) => {
    subMenuParent.addEventListener("click", (e) => {
      const dropdownToggle = subMenuParent.querySelector(".dropdown-toggle");
      const dropdownMenu = subMenuParent.querySelector(".dropdown-menu");
      const navLink = subMenuParent.querySelector(".nav-link");
  
      if (navLink.getAttribute("href") === "#") {
        dropdownToggle.classList.toggle("toggled-on");
        dropdownMenu.classList.toggle("toggled-on");
  
        dropdownMenu.setAttribute(
          "aria-hidden",
          dropdownMenu.getAttribute("aria-hidden") === "true" ? "false" : "true"
        );
  
        dropdownToggle.setAttribute(
          "aria-expanded",
          dropdownToggle.getAttribute("aria-expanded") === "false" ? "true" : "false"
        );
  
        e.stopPropagation();
      }
    });
  });
  
  // Function to handle focusout event
  function focusOut() {
    document.querySelectorAll(".sub-menu-parent .dropdown-menu").forEach((dropdownMenu) => {
      dropdownMenu.addEventListener("focusout", () => {
        setTimeout(() => {
          const isInMenu = document.activeElement.closest(".toggled-on");
  
          if (!isInMenu) {
            document.querySelectorAll(".dropdown-menu").forEach((menu) => {
              menu.classList.remove("toggled-on");
            });
            document.querySelectorAll(".dropdown-toggle").forEach((toggle) => {
              toggle.classList.remove("toggled-on");
            });
          }
        }, 10);
      });
    });
  }
  
  // Call focusOut function if window width is greater than 960 pixels
  if (window.innerWidth > 960) {
    focusOut();
  }


// Fixed nav
const fixedNav = document.querySelector('.fixed-top');

if (fixedNav) {
window.addEventListener('scroll', function() {
if (window.pageYOffset > 20) {
fixedNav.classList.add('scrolled');
} else {
fixedNav.classList.remove('scrolled');
}
});
}

// Transparent nav
const header = document.querySelector("#header");
const headerHeight = header.offsetHeight;
const transparentNav = document.querySelector('.transparent-nav');
const heroImage = document.querySelector('.hero');
const siteBanner = document.querySelector('.site-banner');
// const hamburger = document.querySelector('.hamburger');

if (transparentNav) {
if (heroImage || siteBanner) {
transparentNav.style.marginBottom = -headerHeight + "px";

hamburger.addEventListener("click", function () {
    if (hamburger.classList.contains('is-active')) {
    transparentNav.style.marginBottom = 0;
    } else {
    transparentNav.style.marginBottom = -headerHeight + "px";
    }
    });

} else {
    transparentNav.style.marginBottom = 0;
}
}

// Nav search box
const navSearchButton = document.querySelector("#search-nav-toggler");
const navSearchInput = document.querySelector("#nav-search-field");

if (navSearchButton) {
navSearchButton.addEventListener("click", function() {
navSearchInput.focus();
});
}


//
// Keyboard navigation
//
const menuItems = Array.from(
    document.querySelectorAll(".menu-item a, button.dropdown-toggle")
  );
  
  menuItems.forEach(item => {
    item.addEventListener("keydown", e => {
      if (
        !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.code)
      ) {
        return;
      }
  
      e.stopPropagation();
  
      switch (e.code) {
        case "ArrowLeft": // Left key
          if (item.classList.contains("dropdown-toggle")) {
            item.previousElementSibling.focus();
          } else if (item.parentElement.previousElementSibling &&
            item.parentElement.previousElementSibling.querySelector("button.dropdown-toggle")
          ) {
            item.parentElement.previousElementSibling.querySelector("button.dropdown-toggle").focus();
          } else {
            item.parentElement.previousElementSibling.querySelector("a").focus();
          }
  
          if (item.matches("ul ul ul.sub-menu.toggled-on li:first-child a")) {
            item.parentElement.closest("ul.sub-menu.toggled-on li").querySelector("button.dropdown-toggle").focus();
          }
  
          break;
  
        case "ArrowRight": // Right key
          if (item.nextElementSibling &&
            item.nextElementSibling.matches("button.dropdown-toggle")
          ) {
            item.nextElementSibling.focus();
          } else if (item.parentElement.nextElementSibling &&
            item.parentElement.nextElementSibling.querySelector("input")
          ) {
            item.parentElement.nextElementSibling.querySelector("input").focus();
          } else {
            item.parentElement.nextElementSibling.querySelector("a").focus();
          }
  
          if (item.matches("ul.sub-menu .dropdown-toggle.toggled-on")) {
            item.parentElement.querySelector("ul.sub-menu li:first-child a").focus();
          }
  
          break;
  
        case "ArrowDown": // Down key
          if (item.nextElementSibling) {
            item.nextElementSibling.querySelector("li:first-child a").focus();
          } else if (item.parentElement.nextElementSibling &&
            item.parentElement.nextElementSibling.querySelector("input")
          ) {
            item.parentElement.nextElementSibling.querySelector("input").focus();
          } else {
            item.parentElement.nextElementSibling.querySelector("a").focus();
          }
  
          if (item.matches("ul.sub-menu a") &&
            item.nextElementSibling &&
            item.nextElementSibling.matches("button.dropdown-toggle")
          ) {
            item.parentElement.nextElementSibling.querySelector("a").focus();
          }
  
          if (item.matches("ul.sub-menu .dropdown-toggle") &&
            item.parentElement.nextElementSibling &&
            item.parentElement.nextElementSibling.querySelector(".dropdown-toggle")
          ) {
            item.parentElement.nextElementSibling.querySelector(".dropdown-toggle").focus();
          }
  
          break;
  
        case "ArrowUp": // Up key
          if (item.parentElement.previousElementSibling) {
            item.parentElement.previousElementSibling.querySelector("a").focus();
          } else {
            item.parentElement.closest("ul").previousElementSibling.querySelector(".dropdown-toggle.toggled-on").focus();
          }
  
          if (item.matches("ul.sub-menu .dropdown-toggle") &&
            item.parentElement.previousElementSibling &&
            item.parentElement.previousElementSibling.querySelector(".dropdown-toggle")
          ) {
            item.parentElement.previousElementSibling.querySelector(".dropdown-toggle").focus();
          }
  
          break;
      }
    });
  });

// Hide navbar when scrolling down
let prevScrollpos = window.pageYOffset;
window.onscroll = function() {
  let currentScrollPos = window.pageYOffset;
  let header = document.getElementById("header");
  // Keep header visible if we're near the top (within 150px),
  // or if the user is scrolling up.
  if (prevScrollpos > currentScrollPos || currentScrollPos < 150) {
    header.style.top = "0";
    header.classList.add("scroll-hide");
  } else {
    header.style.top = "-100px";
    header.classList.remove("scroll-hide");
  }

  prevScrollpos = currentScrollPos;
}

menuWithTag();
